<template>
   <section v-if="show" class="cookies-widget-body">
      <div class="cookies-widget-container">
        <div class="cookies-widget-container-button">
          <button type="button" class="btn close-button" @click="rejectCookies">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
        <div class="row mt-2">
          <div class="col-lg-8">
            <h2>Διαχείριση cookies και παρόμοιων τεχνολογιών</h2>
            <p>Πατήστε «Αποδοχή cookies» για την ενεργοποίηση όλων των cookies ή « Απόρριψη cookies» για την ενεργοποίηση
              μόνο της κατηγορίας «Cookies αναγκαία και λειτουργικότητας» ή επιλέξτε «Περισσότερες πληροφορίες» για να επιλέξετε ποια cookies επιθυμείτε να χρησιμοποιηθούν.</p>
          </div>
          <div class="col-lg-4 d-flex flex-column align-self-center">
            <button type="button" class="btn btn-primary btn-block" @click="acceptCookies">Αποδοχή Cookies</button>
            <button type="button" class="btn btn-primary btn-block" @click="rejectCookies">Απόρριψη Cookies</button>
            <button type="button" class="btn btn-link btn-block" @click="infoSettings">Πληροφορίες και ρυθμίσεις</button>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import Cookies from 'js-cookie';
import { bootstrap, setOptions } from 'vue-gtag';

export default {
  data() {
    return {
      show: false
    };
  },
  created() {
    const cookie = Cookies.get('cos_ins_cookie');
    console.log(cookie);
    if (!cookie) {
      this.show = true;
    } else if (Array.from(cookie)[1] === '1') {
      console.log('init analytics');
      this.initAnalytics();
    }
  },
  methods: {
    acceptCookies() {
      this.show = false;
      Cookies.set('cos_ins_cookie', '1111', { expires: 2 });
      this.initAnalytics();
    },
    rejectCookies() {
      this.show = false;
      Cookies.set('cos_ins_cookie', '1000', { expires: 2 });
    },
    infoSettings() {
      this.show = false;
      this.$router.push({ name: 'CookiesManagement' });
    },
    initAnalytics() {
      bootstrap().then((gtag) => {
        console.log(gtag);
        // gtag('event', 'search', {
        //   search_term: 't-shirts'
        // });
        // all done!
      });
      window['ga-disable-G-JSPTB2H75F'] = false;
      setOptions({
        enabled: true
      });
    }
  },
};
</script>

<style lang="scss">
.cookies-widget-body {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(65,65,65,.33);
  height: 100vh;
  z-index: 9999;
  & .cookies-widget-container{
     border-top: 2px solid $primary;
    position: fixed;
    bottom: 0;
    width: 100%;
    min-height: 25%;
    background-color: $white;
    padding: 2rem;
    & .cookies-widget-container-button{
      position: absolute;
      right: 0rem;
      top: 0rem;
      & .close-button{
        font-size: 18px;
      }
    }
  }
}
</style>
